<template>
  <div>
    <Header></Header>
    <section>
      <div class="page_map">
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
        </ol>
      </div>
      <div class="product_info_details">
        <div class="product_info_title">Target ID&species&Class/靶点蛋白ID 和 物种 和分类</div>
        <ul class="product_baseinfo">
          <li>
            <label>Entry / 靶点ID：</label>
            <span>{{ detail.ProteinId }}</span>
            <label>Gene Names / 基因名称：</label>
            <span>{{ detail.GeneNames }}</span>
          </li>
          <li>
            <label>Entry_name / 蛋白名称：</label>
            <span>{{ detail.EntryName }} </span>
            <label>Taxonomy / 分类：</label>
            <span>{{ taxonomy }}</span>
          </li>
          <li>
            <label>Protein names / 蛋白描述：</label>
            <span>
              {{ detail.ProteinDescription }}
            </span>
          </li>
          <li>
            <label>Protein families / 蛋白质家族：</label>
            <span>{{ detail.ProteinFamilies }}</span>
          </li>
          <li>
            <label>Target hierarchy / 靶点层次结构：</label>
            <span>{{ detail.TargetHierarchy }}</span>
          </li>
        </ul>
      </div>

      <div class="product_info_details" v-if="detail['ActiveSite'] && detail['ActiveSite'].length > 0">
        <div class="product_info_title">{{ $t("des.ActIveSite") }}</div>
        <div class="product_info_table">
          <table>
            <thead>
              <tr>
                <th width="60"></th>
                <th>{{ $t("des.ActIveType") }}</th>
                <th>{{ $t("des.ActIvePosition") }}</th>
                <th>{{ $t("des.ActIveDescription") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, key) in detail.ActiveSite" :for="key">
                <td>{{ key + 1 }}</td>
                <td>{{ v.Type }}</td>
                <td>{{ v.Position }}</td>
                <td>{{ v.Description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="product_info_details">
        <div class="product_info_title">{{ $t("des.3DStructure") }}</div>
        <div class="product_info_table">
          <div class="3d_container" id="complex_3d" data-pdb="4FI7" data-ligchain="A" data-reschain="A" data-resinums="15"
            data-tag="1" data-lignums="301">
          </div>
        </div>
      </div>

      <div class="product_info_details">
        <div class="product_info_title">{{ $t("des.ProbeligangList") }}</div>
        <div class="product_info_table">
          <table>
            <thead>
              <tr>
                <th width="60"></th>
                <th>{{ $t("des.ProbeID") }}</th>
                <th>{{ $t("des.Structure") }}</th>
                <th>{{ $t("des.WarheadType") }}</th>
                <th>{{ $t("des.Labelingsites") }}</th>
                <th>{{ $t("des.SOURCE") }}</th>
                <th>{{ $t("des['targetscreeningmethod']")}}</th>
                <th v-if="islogin">{{ $t("des.score") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, key) in allproteinid" :key="key" height="200">
                <td>{{ key + 1 }}</td>
                <td>{{ v.ProbeId }}</td>
                <td style="width:120px"><img :src="setimg(v.ProbeStructImg)" class="setimg" alt="Probe structure" style="min-width: auto;"/></td>
                <td>
                  <div class="typeText">
                    {{ v.ProbeTypeName }}
                  </div>
                  <div class="typeTable">
                    <table>
                      <thead>
                        <tr>
                          <th width="60"></th>
                          <th>Property</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(j, i) in v.MoleculeData" :key="i" v-if="j.Value">
                          <td style="min-width: 50px;">{{ i + 1 }}</td>
                          <td style="min-width: 200px;">{{ $t("des['" + j.Property + "']") }}</td>
                          <td style="min-width: 100px;" >{{ j.Value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
                <td>
                  <div v-html="setwd(v.wdinfo)"></div>
                </td>
                <td>
                  <!--<div v-html="setSourceValue(v, v.Source)" @mouseenter="enter(v.Source)"></div>-->
                  <a href="javascript:void(0)" @click="sourcesOpen(v.Source)" @mouseenter="enter(v.Source)"
                    :title="showtitle">{{
                      v.Source
                    }}</a>
                </td>
                <td>
                  <div class="typeText">
                  {{v.datastandard}}
                  </div>
                  <div class="typeTable">
                    <table>
                      <thead>
                        <tr>
                          <th width="60"></th>
                          <th>{{ $t("des['targetscreeningmethod']")}}</th>
                          <th>{{ $t("des['methoddescription']")}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(j, i) in v.datastandardarr" :key="i" v-if="j.namecn">
                          <td style="min-width: 50px;">{{ i + 1 }}</td>
                          <td style="min-width: 100px;">{{ j.namecn}}</td>
                          <td style="min-width: 200px;" v-if="$i18n.locale=='zh'">{{ j.content }}</td>
                          <td style="min-width: 200px;" v-if="$i18n.locale!='zh'">{{ j.contenten }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                </td>
                <td v-if="islogin">
                  <div v-if="v.allscore&&v.allscore.length">
                    <div v-for="(s) in [5,4,3,2,1]">
                      <img v-for="(star,index) in [5,4,3,2,1]"  :src="index+1<=s?starOnImg:starOffImg" alt="星星图片" width="30" />
                      {{ v.allscore[s-1] }} 
                    </div>
                    <button @click="canclescore(key,v.ProbeId)">{{ $t("des.cancelscore") }}</button>
                  </div>
                  <div v-if="!v.allscore||!v.allscore.length">
                    <img v-for="(star,index) in stars"  :src="!star.active[key]?star.src:star.activeSrc[key]" @click="rating(index,key,v.ProbeId)" alt="星星图片" width="30" />
                  </div>
                </td>
              </tr>


            </tbody>
          </table>
        </div>
      </div>

      <div class="product_info_details">
        <div class="product_info_title" v-if="detail['goall'] && detail['goall'].length > 0">Annotation & Location/注释和位置
        </div>
        <div class="product_info_table" v-if="detail['goall'] && detail['goall'].length > 0">
          <table>
            <thead>
              <tr>
                <th width="578">{{ $t("des.goclass") }}</th>
                <th width="578">{{ $t("des.goDescription") }}</th>
                <th>{{ $t("des.gono") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, key) in detail['goall']" :for="key">
                <td>{{ v['title'] }}</td>
                <td>
                  <div v-for="(val, index) in v['detail']" :for="index"
                    :class="{ 'hight': isactive == index + v['title'] }" @mouseover="Mouseover(index, v['title'])"
                    @mouseleave="Mouseleave(index)">
                    {{ val['No'] ? val['No'] : "-" }} <br>
                  </div>
                  <label v-if="v['detail'].length == 0">-</label>
                </td>
                <td>
                  <div v-for="(val, index) in v['detail']" :for="index"
                    :class="{ 'hight': isactive == index + v['title'] }" @mouseover="Mouseover(index, v['title'])"
                    @mouseleave="Mouseleave(index)">
                    <a :href="'https://amigo.geneontology.org/amigo/medial_search?q=' + val['Term']" target="_blank">{{
                      val['Term'] ? val['Term'] : "-" }}</a>
                    <br>
                  </div>
                  <label v-if="v['detail'].length == 0">-</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="product_info_table" v-if="detail['CellularLocation'] && detail['CellularLocation'].length > 0">
          <table>
            <thead>
              <tr>
                <th width="60"></th>
                <th width="870">{{ $t("des.cellularlocation") }}</th>
                <!-- <th>Evidance</th> -->
              </tr>
            </thead>
            <tbody>

              <tr v-for=" (v, key) in detail.CellularLocation" :for="key" v-if="v.Location || v.Evidance">

                <td>{{ key + 1 }}</td>
                <td>{{ v.Location }}</td>
                <!-- <td>{{ v.Evidance }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="product_info_table" v-if="detail['KeggPathway'] && detail['KeggPathway'].length > 0">
          <table>
            <thead>
              <tr>
                <th width="60"></th>
                <th width="870">{{ $t("des.KEGGNo") }}</th>
                <th>{{ $t("des.KEGGterm") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (v, key) in detail.KeggPathway" :for="key">
                <td>{{ key + 1 }}</td>
                <td><a :href="v.No ? 'https://www.kegg.jp/pathway/' + v.No : '#'" target="_blank">{{ v.No }}</a></td>
                <td>{{ v.Term }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="product_info_details" v-if="detail.Disease && detail.Disease.length > 0">
        <div class="product_info_title">{{ $t("des.DiseaseDrug") }}</div>
        <div class="product_info_table">
          <table>
            <thead>
              <tr>
                <th width="60"></th>
                <th width="235">{{ $t("des.Disease") }}</th>
                <th width="235">{{ $t("des.MIMNo") }}</th>
                <th>{{ $t("des.Description") }}</th>
                <th width="280">{{ $t("des.Evidence") }}</th>
                <th width="280">{{ $t("des.Note") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (v, key) in detail.Disease" :for="key">
                <td>{{ key + 1 }}</td>
                <td>{{ v.Disease }}</td>
                <td>{{ v.MimNo }}</td>
                <td>
                  {{ v.Description }}
                </td>
                <td>{{ v.Evidence }}</td>
                <td>{{ v.Note }}</td>
              </tr>
            </tbody>
          </table>
        </div>


        <h2 v-if="detail.DrugBank && detail.DrugBank.length > 0">DrugBank</h2>
        <div class="product_info_table" v-if="detail.DrugBank && detail.DrugBank.length > 0">
          <table>
            <thead>
              <tr>
                <th width="33.3333%">DrugBank</th>
                <th width="33.3333%">Drug Name</th>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (v, key) in detail.DrugBank" :for="key">
                <td>{{ v.DrugBank }}</td>
                <td>{{ v.DrugName }}</td>
                <td>{{ v.Group }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 v-if="detail.DrugCrntral && detail.DrugCrntral.length > 0">DrugCentral</h2>
        <div class="product_info_table" v-if="detail.DrugCrntral && detail.DrugCrntral.length > 0">
          <table>
            <thead>
              <tr>
                <th width="33.3333%">DrugCentral ID</th>
                <th width="33.3333%">Drug Name</th>
                <th>ACT_SOURCE</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (v, key) in detail.DrugCrntral" :for="key">
                <td>{{ v.DrugCrntralId }}</td>
                <td>{{ v.DrugName }}</td>
                <td>{{ v.ActSource }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2 v-if="detail.ChEMBL">ChEMBL</h2>
        <div class="product_info_table" v-if="detail.ChEMBL">
          {{ detail.ChEMBL }}
        </div>
        <h2 v-if="detail.KeggDrug.length > 0">KEGG Drug</h2>
        <div class="product_info_table" v-if="detail.KeggDrug && detail.KeggDrug.length > 0">
          <table>
            <thead>
              <tr>
                <th width="50%">KEGG DRUG ID</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (v, key) in detail.KeggDrug" :for="key">
                <td>{{ v.KeggDrugId }}</td>
                <td>{{ v.Name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <div class="pop_bg" v-show="popBgShow" @click="closeAll()"></div>
    <div class="pop_data_sources" v-show="popSourcesShow">
      <div class="header_info">
        <div class="title">数据来源{{ syData.datacode }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： {{ syData.experimentnumber }}<br>
        实验日期：{{ syData.implementationdate ? syData.implementationdate : "" }}<br>
        实验设计（模板）：<div v-html="syData.designexperiments"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
var starOffImg = "data:image/png;base64,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";
var starOnImg = "data:image/png;base64,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";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      islogin: false,
      username: "",
      starOffImg:starOffImg,
      starOnImg:starOnImg,
      detail: {
      },
      allproteinid: [],
      taxonomy: '',
      showtitle: '',
      syData: {},
      popBgShow: false,
      popSourcesShow: false,
      isactive: [],
      stars: [{
            src: starOffImg,
            active: [false,false,false,false,false],
            activeSrc:[false,false,false,false,false],
            
          }, {
            src: starOffImg,
            active: [false,false,false,false,false],
            activeSrc:[false,false,false,false,false],
          }, {
            src: starOffImg,
            active:[false,false,false,false,false],
            activeSrc:[false,false,false,false,false],
          },
          {
            src: starOffImg,
            active: [false,false,false,false,false],
            activeSrc:[false,false,false,false,false],
          }, {
            src: starOffImg,
            active: [false,false,false,false,false],
            activeSrc:[false,false,false,false,false],
          }
      ],
      starNum: [0,0,0,0,0],
    }
  },
  created() {
    this.islogin = localStorage.getItem("isLogined");
    this.username = localStorage.getItem("username");
    this.getdetailData();
    this.getProteinIdData();
    this.getProteinsCategoryData();
  },
  mounted: function () {
    let that = this;
  },
  methods: {
    canclescore(key,ProbeId){
      var that=this;
      this.isl = localStorage.getItem("isLogined");
      let urllist = '/action/ejatglkvakzowpjax/canclescore';
      var scoreform={
            LDDBid: that.$route.query.LDDBid,
            ProbeID: ProbeId,
            username:that.username,
            isl:that.islogin
      };
      api.getTableData(urllist, JSON.stringify(scoreform)).then(res => {
        if (res.result == 1) {
          that.showInfo('取消成功');
          that.allproteinid[key]['allscore']=[];
          this.$set(that.allproteinid,key,that.allproteinid[key]);
          for(var i = 0; i < 5; i++) {
            that.stars[i].active[key] = false;
            that.stars[i].activeSrc[key]=that.starOffImg;
            this.$set(that.stars,i,that.stars[i]);
          }
        }else{
          that.showInfo('取消失败');
        }
      });
    }, 

    addconfirm(score,ProbeID,key) {
      var that=this;
        let urllist = '/action/ejatglkvakzowpjax/andscore';
        var scoreform={
              LDDBid: that.$route.query.LDDBid,
              score: score,
              ProbeID: ProbeID,
              username:that.username,
              isl:that.islogin
          };
        api.getTableData(urllist, JSON.stringify(scoreform)).then(res => {
          if (res.result == 1) {
            if(res.message=="无打分权限"){
              that.showInfo(res.message);
            }else{
              that.showInfo('提交成功');
              var nscore=[0,0,0,0,0];
              res.data.forEach(function(val){
                nscore[val._id-1]=val.sum;
              })
              that.allproteinid[key]['allscore']=nscore;
              this.$set(that.allproteinid,key,that.allproteinid[key]);
            }

          }
        });
    },
    rating: function(index,key,ProbeId) {
      var that=this;
      let urllist = '/action/ejatglkvakzowpjax/corights';
        var scoreform={
              username:that.username,
              isl:that.islogin
          };
        api.getTableData(urllist, JSON.stringify(scoreform)).then(res => {
          if (res.result == 1) {
            if(res.message=="无打分权限"){
              that.showInfo('无打分权限');
            }else{
              var total = that.stars.length; //星星总数
              var idx = index + 1; //这代表选的第idx颗星-也代表应该显示的星星数量
              //进入if说明页面为初始状态
              if(that.starNum[key] == 0) {
                that.starNum[key] = idx;
                  for(var i = 0; i < idx; i++) {
                    that.stars[i].active[key] = true;
                    that.stars[i].activeSrc[key]=starOnImg;
                    that.$set(that.stars,i,that.stars[i]);
                  }
              } else {
                  //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
                  if(idx == that.starNum[key]) {
                      for(var i = index; i < total; i++) {
                          //this.stars[i].src = starOffImg;
                          that.stars[i].active[key] = false;
                          that.stars[i].activeSrc[key]=starOffImg;
                          that.$set(that.stars,i,that.stars[i]);
                      }
                  }
                  //如果小于当前最高星级，则直接保留当前星级
                  if(idx < that.starNum[key]) {
                      for(var i = idx; i < that.starNum[key]; i++) {
                        // this.stars[i].src = starOffImg;
                        that.stars[i].active[key] = false;
                        that.stars[i].activeSrc[key]=starOffImg;
                        that.$set(that.stars,i,that.stars[i]);
                      }
                  }
                  //如果大于当前星级，则直接选到该星级
                  if(idx > that.starNum[key]) {
                      for(var i = 0; i < idx; i++) {
                        // this.stars[i].src = starOnImg;
                        that.stars[i].active[key] = true;
                        that.stars[i].activeSrc[key]=starOnImg;
                        that.$set(that.stars,i,that.stars[i]);
                      }
                  }
                  var count = 0; //计数器-统计当前有几颗星
                  for(var i = 0; i < total; i++) {
                      if(that.stars[i].active[key]) {
                          count++;
                      }
                  }
                  that.starNum[key] = count;
                  
              }
              that.addconfirm(that.starNum[key],ProbeId,key);
            }
          }
        });

    },
    Mouseover(index, title) {
      this.isactive = index + title;
    },
    Mouseleave(index) {
      this.isactive = -1;
    },
    closeAll() {
      this.popBgShow = false;
      this.popSourcesShow = false;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }
    },
    async getdsjyData(val) {
      //查询数据源
      var that = this;
      var postdata = {
        "datacode": val
      };
      let urllist = '/action/egxqivukrqpdlzsjz/getdata';
      that.isarticle = false;
      if (val.indexOf('LDRA') != -1) {
        urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        that.isarticle = true;
      }
      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.syData = res.data.rows[0];
          if (that.isarticle) {
            window.open(that.syData.essayurl);
          }

        }
      });
    },
    enter(val) {
      var that = this;
      if (val.indexOf('LDRA') != -1) {
        var postdata = {
          "datacode": val
        };
        var urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
          if (res.data && res.data.rows.length > 0) {
            that.showtitle = res.data.rows[0].essaydoi;
          }
        });
      }
      that.showtitle = "";
    },
    setSourceValue(item, value) {
      return value;
      var rethtml = '';
      if (value == 0) {
        //文献
        if (item.References != null && item.References.lenght != 0) {
          for (var i = 0; i < item.References.length; i++) {
            if (rethtml.length > 0) {
              rethtml += "<br/>";
            }
            var url = item.References[i]["Url"];
            if (url != null && url != '') {
              rethtml += '<a href="' + url + '" target="_blank">' + item.References[i].No + '</a>';
            } else {
              rethtml += item.References[i].No;
            }
          }
        }
      } else {
        //实验记录
        rethtml = item.RecordNo;
      }
      return rethtml;
    },
    setwd(val) {
      if (val) {
        let newvd = val.split("\n");
        let wdstring = newvd.join("<br>");
        return wdstring;
      }

    },
    setimg(value) {
      if (value != null && value.val != null) {
        var ImgUrl = value.val.url;
        if (ImgUrl != null && ImgUrl != '') {
          return ImgUrl;
        }
      }
      return "";
    },
    resetVal(val, title) {
      let newval = "";
      if (val == undefined) {
        return "";
      }
      val.forEach(function (item) {
        newval += item[title] + "<br>";
      })
      return newval;
    },

    async getdetailData() {

      //查询详情
      var that = this;

      that.LDDBid = this.$route.query.LDDBid;
      let urllist = '/action/etpdxwptrnxiwushd/detail';
      await api.getTableData(urllist, JSON.stringify({ LDDBid: that.LDDBid })).then(res => {
        if (res.data&&res.data.rows) {

          that.detail = res.data.rows[0];

          that.detail['goall'] = [];
          that.detail['goall'].push({ title: "biological process", detail: that.detail["GoBp"] });
          that.detail['goall'].push({ title: "cellular component", detail: that.detail["GoCc"] });
          that.detail['goall'].push({ title: "molecular function", detail: that.detail["GoMf"] });
          if (that.detail['3DStructure'] && that.detail['3DStructure'].val && that.detail['3DStructure'].val.url) {
            $(show_what(that.detail['3DStructure'].val.url))
          }
        }
      });


    },
    async getProteinIdData() {
      //查询详情
      var that = this;
      let prolist = '/action/egiohnwpnwarmiivu/getproteinids';
      that.allproteinid = [];
      await api.getTableData(prolist, JSON.stringify({ LDDBid: this.$route.query.LDDBid,"username": that.username})).then(res => {
        if (res.data) {
          var msg = res.data;
          msg.forEach(function (val) {
            let arr = JSON.parse(JSON.stringify(val));
            if(arr.allscore&&arr.allscore.length){
              var nscore=[0,0,0,0,0];
              arr.allscore.forEach(function(val){
                nscore[val._id-1]=val.sum;
              });
              arr['allscore']=nscore;
            }
            that.allproteinid.push(arr);
          })
          console.log(that.allproteinid);
        }
      });
    },
    async getProteinsCategoryData() {
      //靶点分类查询详情
      var that = this;
      let Categorylist = '/action/ekalwossygsylkzww/getProteinsCategory';
      if (this.$route.query.ProteinsCategoryId) {
        let ProteinsCategoryId = { '$oid': this.$route.query.ProteinsCategoryId };
        await api.getTableData(Categorylist, JSON.stringify({ _id: ProteinsCategoryId })).then(res => {
          if (res.data) {
            that.taxonomy = res.data.rows[0]['CategoryName'];
          }
        });
      }
    },
    showInfo(val) {
      toastr.info(val, "提醒", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    }
  }
}
</script>
<style>
#complex_3d {
  width: 100%;
  height: 400px;
  position: relative;
}

.hight {
  color: blue
}

.hight a {
  color: blue
}

.text-warning {
    color: #ffc107!important;
}
</style>


// WEBPACK FOOTER //
// src/views/Desc.vue